// src/api/userApi.js
import { api_path } from "../shared.js";

const BASE       = `${api_path}/user/users.php`;
const AUTH_TOKEN = process.env.REACT_APP_API_TOKEN || "";

async function request(method, params, body) {
  const url = params ? `${BASE}?${new URLSearchParams(params)}` : BASE;
  const res  = await fetch(url, {
    method,
    credentials: "include",
    headers: {
      "Content-Type":  "application/json",
      "Authorization": AUTH_TOKEN ? `Bearer ${AUTH_TOKEN}` : "",
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message ?? "API error");
  return json;   // คืน { success, status, message, data, total? }
}

export const userApi = {
  getAll:  (filters)    => request("GET",    filters ?? {}),
  getOne:  (id)         => request("GET",    { id }),
  create:  (payload)    => request("POST",   null,   payload),
  update:  (id, payload) => request("PUT",   { id }, payload),
  delete:  (id)         => request("DELETE", { id }),
};
